import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NAV_STATE_TYPE {
  visible: boolean;
  minimized: boolean;
  topNavData: string;
  darkMode: boolean;
  overlayOpen: boolean;
}

const INITIAL_STATE: NAV_STATE_TYPE = {
  visible: false,
  minimized: true,
  topNavData: '',
  darkMode: false,
  overlayOpen: false,
};

const navSlice = createSlice({
  name: 'navigation',
  initialState: INITIAL_STATE,
  reducers: {
    setSidenavVisible(state: NAV_STATE_TYPE, action: PayloadAction<boolean>) {
      state.visible = action.payload;
    },
    setSidenavMinimized(state: NAV_STATE_TYPE, action: PayloadAction<boolean>) {
      state.minimized = action.payload;
    },
    setTopNavData(state: NAV_STATE_TYPE, action: PayloadAction<string>) {
      state.topNavData = action.payload;
    },
    setDarkMode(state: NAV_STATE_TYPE, action: PayloadAction<boolean>) {
      state.darkMode = action.payload;
    },
    setOverlayOpen(state: NAV_STATE_TYPE, action: PayloadAction<boolean>) {
      state.overlayOpen = action.payload;
    },
  },
});

export const {
  setSidenavVisible,
  setSidenavMinimized,
  setTopNavData,
  setDarkMode,
  setOverlayOpen,
} = navSlice.actions;
export default navSlice.reducer;
